import React from 'react';
export const DefaultNoDataComponent = ({
  noDataText,
  className,
  style
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style
  }, noDataText);
};